export class Comissao{
    comissionPercentage!: number;
    monthlyPayment!: boolean;
    rBalance!: number;
    xBalance!: number;
}